<template>
  <el-dialog
    v-drag
    v-loading="laoding"
    :visible.sync="dialogVisible"
    width="1340px"
    :title="`${!type ? '应收' : '应付'}审核费用`"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
    top="1%"
  >
    <div class="content">
      <div class="header">
        <div class="item">
          <span class="label">单号</span>
          <span class="value">{{ rowData.serviceNo }}</span>
        </div>
        <div class="item">
          <span class="label">客户</span>
          <span class="value">{{ rowData.companyName }}</span>
        </div>
        <div class="item">
          <span class="label">业务类型</span>
          <span class="value">{{ rowData.companyName }}</span>
        </div>
        <div class="item">
          <span class="label">参考单号1</span>
          <span class="value">{{ rowData.referenceNumber }}</span>
        </div>
        <div class="item">
          <span class="label">参考单号2</span>
          <span class="value">{{ rowData.referenceNumber2 }}</span>
        </div>
        <div class="item">
          <span class="label">需求补充</span>
          <span class="value">{{ rowData.demandAdditional }}</span>
        </div>
        <div class="item">
          <span class="label">创建人</span>
          <span class="value">{{ rowData.createdName }}</span>
        </div>
        <div class="item">
          <span class="label">创建时间</span>
          <span class="value">{{ rowData.createdOn }}</span>
        </div>
        <div class="item">
          <span class="label">进入时间</span>
          <span class="value">{{ rowData.entryTime }}</span>
        </div>
        <div class="item">
          <span class="label">附件数</span>
          <span class="value">{{ rowData.attachmentCount }}</span>
        </div>
        <div class="item" style="display: flex">
          <el-input-number
            ref="inputNumber"
            v-model="entry"
            :min="0"
            :max="100"
            style="width: 125px"
            :disabled="rowData.status !== 3 && rowData.status !== 4"
            @keyup.enter.native="newAdd"
            @focus="$refs.inputNumber.select()"
          ></el-input-number>
          <div
            class="btn"
            style="width: 60px; margin-left: 10px"
            type="primary"
            @click="newAdd"
          >
            增加
          </div>
        </div>
      </div>
      <div class="data">
        <VisTableComponents
          ref="visTable"
          componentId="visTable"
          :options="{
            ...tableData,
            headerStyle,
            bodyStyle,
            columns,
          }"
          style="max-height: 550px"
          @editChange="editChange"
          @iconClick="iconClick"
        ></VisTableComponents>
        <div class="total">
          <span class="total-item">
            共
            <span class="num"> {{ tableData.data.length }} </span>
            条
          </span>
          <span class="total-item">
            应收合计
            <span class="num"> ${{ receivableTotalAmount.toFixed(2) }} </span>
          </span>
          <span class="total-item">
            应付合计
            <span class="num"> ${{ payableTotalAmount.toFixed(2) }} </span>
          </span>
          <span class="total-item">
            利润
            <span class="num">
              ${{ (receivableTotalAmount - payableTotalAmount).toFixed(2) }}
            </span>
          </span>
        </div>
      </div>
    </div>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取消</div>
      <div v-debounce-click="{ value: ok, args: [0] }" class="ok flex_c_c">
        保存
      </div>
      <div
        v-if="(type === 1 && rowData.status > 3) || rowData.status === 3"
        v-debounce-click="{ value: ok, args: [1] }"
        class="ok flex_c_c"
      >
        保存并审核
      </div>
    </span>
  </el-dialog>
</template>

<script>
const VisTableComponents = () => import('@/components/base/VisTableComponents')
import { GetFeeNameListById } from '@/api/fee'
import {
  uploadOtherServiceExpenses,
  getExpensesList,
  uploadAndAuditExpenses,
  uploadBilledReceivableExpenses,
  deleteExpenses
} from '@/api/other'
import { SelectEditor } from '@/utils/VTableConfig'
import { keepTwoDecimal } from '@/utils/common'
export default {
  components: {
    VisTableComponents
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {}
    },
    type: {
      type: Number,
      default: 0 // 0 = receivable(receivable), 1 = payable(payable)
    }
  },
  data() {
    return {
      laoding: false,
      tableData: {
        data: [],
        // headerStyle: {
        //   bgColor: ({ col, row }) => {
        //     if (col === 1 && row < 1) {
        //       return '#C7E1F5'
        //     } else if (row > 0 && col > 0 && col < 6) {
        //       return '#eff8ff'
        //     } else if (col === 6 && row === 0) {
        //       return '#D6F3E6'
        //     } else if (row > 0 && col > 5 && col < 12) {
        //       return '#f4fcf9'
        //     } else {
        //       return '#F7F7F7'
        //     }
        //   },
        //   fontSize: 14
        // },
        // bodyStyle: {
        //   bgColor: ({ col }) => {
        //     if (col > 0 && col < 6) {
        //       return '#eff8ff'
        //     } else if (col > 5 && col < 11) {
        //       return '#f4fcf9'
        //     }
        //   },
        //   fontSize: 14
        // },
        rightFrozenColCount: 1
      },
      entry: 0,
      feeOptions: [],
      headerIcon: {
        type: 'svg',
        positionType: this.$VTable.TYPES.IconPosition.contentLeft,
        width: 15,
        height: 15,
        svg: '<svg class="icon" width="200px" height="200.00px" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M534.869333 490.496a1403.306667 1403.306667 0 0 0 50.858667-25.813333c16.042667-8.618667 29.013333-15.061333 38.570667-19.029334 9.557333-3.925333 17.066667-6.058667 22.869333-6.058666 9.557333 0 17.749333 3.2 24.917333 10.026666 6.826667 6.826667 10.581333 15.061333 10.581334 25.088 0 5.76-1.706667 11.818667-5.12 17.92-3.413333 6.101333-7.168 10.069333-10.922667 11.861334-35.157333 14.677333-74.410667 25.429333-116.736 31.872 7.850667 7.168 17.066667 17.237333 28.330667 29.781333 11.264 12.544 17.066667 18.986667 17.749333 20.053333 4.096 6.101333 9.898667 13.653333 17.408 22.613334 7.509333 8.96 12.629333 15.786667 15.36 20.778666 2.730667 5.034667 4.437333 11.093333 4.437333 18.304a33.706667 33.706667 0 0 1-9.898666 24.021334 33.834667 33.834667 0 0 1-25.6 10.410666c-10.24 0-22.186667-8.618667-35.157334-25.472-12.970667-16.512-30.037333-46.933333-50.517333-91.050666-20.821333 39.424-34.816 65.962667-41.642667 78.506666-7.168 12.544-13.994667 22.186667-20.48 28.672a30.976 30.976 0 0 1-22.528 9.685334 32.256 32.256 0 0 1-25.258666-11.093334 35.413333 35.413333 0 0 1-9.898667-23.68c0-7.893333 1.365333-13.653333 4.096-17.578666 25.258667-35.84 51.541333-67.413333 78.848-93.568a756.650667 756.650667 0 0 1-61.44-12.544 383.061333 383.061333 0 0 1-57.685333-20.48c-3.413333-1.749333-6.485333-5.717333-9.557334-11.818667a30.208 30.208 0 0 1-5.12-16.853333 32.426667 32.426667 0 0 1 10.581334-25.088 33.152 33.152 0 0 1 24.234666-10.026667c6.485333 0 14.677333 2.133333 24.576 6.101333 9.898667 4.266667 22.186667 10.026667 37.546667 18.261334 15.36 7.893333 32.426667 16.853333 51.882667 26.538666-3.413333-18.261333-6.485333-39.082667-8.874667-62.378666-2.389333-23.296-3.413333-39.424-3.413333-48.042667 0-10.752 3.072-19.712 9.557333-27.264A30.677333 30.677333 0 0 1 512.341333 341.333333c9.898667 0 18.090667 3.925333 24.576 11.477334 6.485333 7.893333 9.557333 17.92 9.557334 30.464 0 3.584-0.682667 10.410667-1.365334 20.48-0.682667 10.368-2.389333 22.570667-4.096 36.906666-2.048 14.677333-4.096 31.146667-6.144 49.834667z" fill="#FF3838" /></svg>'
      },
      // 费用项下拉框设置
      feeNameList: ({ row }) => {
        if (
          this.tableData.data[row - 2]?.payableStatus < 2 ||
          !this.tableData.data[row - 2]?.payableStatus
        ) {
          return 'feeNameList'
        }
      },
      // 纯数字输入框设置
      // numberEditor: ({ row }) => {
      //   if (
      //     this.tableData.data[row - 2]?.payableStatus < 2 ||
      //     !this.tableData.data[row - 2]?.payableStatus
      //   ) {
      //     return 'numberEditor'
      //   }
      // },
      // 数字加小数点输入框设置
      pointEditor: ({ row }) => {
        if (
          this.tableData.data[row - 2]?.payableStatus < 2 ||
          !this.tableData.data[row - 2]?.payableStatus
        ) {
          return 'pointEditor'
        }
      },
      pointEditorRe: ({ row }) => {
        if (
          this.tableData.data[row - 2]?.receivableStatus < 2 ||
          !this.tableData.data[row - 2]?.receivableStatus
        ) {
          return 'pointEditor'
        }
      },
      textareaEditor: ({ row }) => {
        if (
          this.tableData.data[row - 2]?.payableStatus < 2 ||
          !this.tableData.data[row - 2]?.payableStatus
        ) {
          return 'textareaEditor'
        }
      },
      inpnutEdit: ({ row }) => {
        if (
          this.tableData.data[row - 2]?.payableStatus < 2 ||
          !this.tableData.data[row - 2]?.payableStatus
        ) {
          return 'inpnutEdit'
        }
      },
      sortObj: {
        sortBy: '',
        sortField: ''
      }
    }
  },
  computed: {
    receivableTotalAmount() {
      return this.tableData.data.reduce((prev, next) => {
        return (prev += next.receivableCount * next.receivableUnitPrice)
      }, 0)
    },
    payableTotalAmount() {
      return this.tableData.data.reduce((prev, next) => {
        return (prev += next.payableCount * next.payableUnitPrice)
      }, 0)
    },
    columns() {
      const arr = [
        {
          field: 'feeName',
          title: '费用项',
          width: '160',
          editor: this.feeNameList,
          headerIcon: this.headerIcon,
          sort: true
        },
        {
          field: 'receivableStatus',
          title: '应收',
          columns: [
            {
              field: 'receivableStatus',
              title: '状态',
              width: '130',
              fieldFormat: (row) => {
                const obj = {
                  0: '未录入',
                  1: '已录入',
                  2: '已审核',
                  3: '已扣费'
                }
                return row.receivableStatus ? obj[row.receivableStatus] : ''
              },
              sort: true
            },
            {
              field: 'receivableCount',
              title: '数量',
              width: '130',
              editor: this.pointEditorRe,
              headerIcon: this.headerIcon,
              sort: true
            },
            {
              field: 'receivableUnitPrice',
              title: '单价',
              width: '130',
              editor: this.pointEditorRe,
              fieldFormat: (row) =>
                '$' + Number(row.receivableUnitPrice).toFixed(3),
              style: { color: '#FE453D' },
              headerIcon: this.headerIcon,
              sort: true
            },
            {
              field: 'receivableAmount',
              title: '金额',
              width: '130',
              fieldFormat: (row) => {
                row.receivableAmount =
                  +row.receivableCount * +row.receivableUnitPrice
                return (
                  '$' +
                  (keepTwoDecimal((+row.receivableCount * +row.receivableUnitPrice))).toFixed(2)
                )
              },
              style: { color: '#FE453D' },
              headerIcon: this.headerIcon,
              sort: true
            },
            {
              field: 'receivableRemark',
              title: '备注',
              width: '200',
              editor: this.textareaEditor
            }
          ]
        },
        {
          field: 'feeName',
          title: '应付',
          columns: [
            {
              field: 'payableStatus',
              title: '状态',
              width: '130',
              fieldFormat: (row) => {
                const obj = {
                  0: '未录入',
                  1: '已录入',
                  2: '已审核',
                  3: '已申付'
                }
                return row.payableStatus ? obj[row.payableStatus] : ''
              },
              sort: true
            },
            {
              field: 'payableCount',
              title: '数量',
              width: '130',
              editor: this.pointEditor,
              headerIcon: this.headerIcon,
              sort: true
            },
            {
              field: 'payableUnitPrice',
              title: '单价',
              width: '130',
              editor: this.pointEditor,
              fieldFormat: (row) =>
                '$' + Number(row.payableUnitPrice).toFixed(3),
              style: { color: '#FE453D' },
              headerIcon: this.headerIcon,
              sort: true
            },
            {
              field: 'payableAmount',
              title: '金额',
              width: '130',
              fieldFormat: (row) => {
                row.payableAmount = +row.payableCount * +row.payableUnitPrice
                return (
                  '$' + (+row.payableCount * +row.payableUnitPrice).toFixed(2)
                )
              },
              style: { color: '#FE453D' },
              headerIcon: this.headerIcon,
              sort: true
            },
            {
              field: 'payableRemark',
              title: '备注',
              width: '200',
              editor: this.textareaEditor
            },
            {
              field: 'mblSendwayRemark',
              title: '派送方式',
              width: '130',
              editor: this.inpnutEdit
            }
          ]
        },
        {
          field: 'creater',
          title: '录入人',
          width: '130'
        },
        {
          field: 'createOn',
          title: '录入时间',
          width: '150',
          fieldFormat: (row) =>
            row.createOn ? row.createOn.slice(0, row.createOn.length - 3) : ''
        },
        {
          field: 'auditor',
          title: '审核人',
          width: '130'
        },
        {
          field: 'auditOn',
          title: '审核时间',
          width: '150',
          fieldFormat: (row) =>
            row.auditOn ? row.auditOn.slice(0, row.auditOn.length - 3) : '',
          sort: true
        }
      ]
      if (this.type) {
        arr.splice(1, 1, {
          field: 'invoiceNumber',
          title: '发票号',
          width: '160',
          editor: this.inpnutEdit,
          headerIcon: this.headerIcon
        })
      } else {
        arr.splice(2, 1)
      }
      if (this.rowData.status === 3) {
        arr.push({
          field: 'opt',
          title: '操作',
          width: '80',
          icon: ({ row }) => {
            if (
              this.tableData.data[row - 2]?.payableStatus < 3 ||
              !this.tableData.data[row - 2]?.payableStatus
            ) {
              return {
                name: 'delete',
                type: 'svg',
                marginLeft: 15,
                color: '#2395F3',
                positionType: 'left',
                width: 20,
                height: 20,
                svg: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><defs><style>.a{fill:none;}.b{fill:#2395f3;fill-rule:evenodd;}</style></defs><rect class="a" width="20" height="20"/><path class="b" d="M35.754,25h.914a2.469,2.469,0,0,1,2.494,2.577h3.824a.665.665,0,1,1,0,1.33h-.5V37.47A2.841,2.841,0,0,1,39.744,40.3H32.678a2.841,2.841,0,0,1-2.743-2.827V28.907h-.5a.665.665,0,1,1,0-1.33H33.26A2.469,2.469,0,0,1,35.754,25ZM38.5,31.152v5.487a.707.707,0,0,1-1.413,0V31.152A.707.707,0,0,1,38.5,31.152Zm-3.159,0v5.487a.707.707,0,0,1-1.413,0V31.152A.707.707,0,0,1,35.338,31.152Zm5.736-2.245h-9.81V37.47a1.457,1.457,0,0,0,1.413,1.413h7.066a1.385,1.385,0,0,0,1.33-1.413Zm-4.406-2.494h-.914a1.4,1.4,0,0,0-.831.249,1.4,1.4,0,0,0-.249.831h3.076a1.067,1.067,0,0,0-.333-.831A1.016,1.016,0,0,0,36.668,26.413Z" transform="translate(-26.36 -22.922)"/></svg>',
                cursor: 'pointer'
              }
            }
          }
        })
      }
      return arr
    },
    headerStyle() {
      return {
        bgColor: ({ col, row }) => {
          if ((col === 1 && row < 1) && !this.type) {
            return '#C7E1F5'
          } else if ((row > 0 && col > 0 && col < 6) && !this.type) {
            return '#eff8ff'
          } else if ((col === 2 && row < 1) && this.type) {
            return '#D6F3E6'
          } else if ((row > 0 && col > 0 && col < 8) && this.type) {
            return '#f4fcf9'
          } else {
            return '#F7F7F7'
          }
        },
        fontSize: 14
      }
    },
    bodyStyle() {
      return {
        bgColor: ({ col }) => {
          if ((col > 0 && col < 6) && !this.type) {
            return '#eff8ff'
          } else if ((col > 1 && col < 8) && this.type) {
            return '#f4fcf9'
          }
        },
        fontSize: 14
      }
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        // this.$nextTick(() => {
        //   this.$refs.visTable.render()
        // })
        if (this.rowData.status !== 3) {
          this.tableData.rightFrozenColCount = 0
        }
        this.getExpensesList()
      }
    }
  },
  async mounted() {
    await this.GetFeeNameList()
    this.$VTable.register.editor(
      `feeNameList`,
      new SelectEditor({ values: this.feeOptions.map((a) => a.label) })
    )
  },
  methods: {
    reset() {
      this.tableData.rightFrozenColCount = 1
      this.entry = 0
      this.tableData.data = []
    },
    async getExpensesList() {
      try {
        const res = await getExpensesList({
          id: this.rowData.id,
          type: this.type
        })
        if (res.success) {
          this.tableData.data = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    cancel() {
      this.reset()
      this.$emit('cancel')
    },
    async ok(type) {
      if (!this.tableData.data.length) {
        this.$message.error('请添加录入数据')
        return
      }
      let flag = true
      this.tableData.data.some((a) => {
        if (this.type) {
          if (!a.feeNameId || !a.payableCount) {
            flag = false
            return
          }
        } else {
          if (!a.feeNameId || !a.receivableCount) {
            flag = false
            return
          }
        }
      })
      if (!flag) {
        this.$message.error('请将必填项填写完整')
        return
      }
      this.loading = true
      const waitChackFlag = this.tableData.data.find(
        (a) => !a.receivableStatus
      )
      if (waitChackFlag && !type && this.rowData.status === 4) {
        try {
          const res = await uploadBilledReceivableExpenses({
            id: this.rowData.id,
            list: this.tableData.data,
            type: this.type
          })
          this.loading = false
          if (res.success) {
            this.$emit('ok')
            this.reset()
            this.$message.success(res.errorMessage)
          } else {
            this.$message.error(res.errorMessage)
          }
        } catch (error) {
          console.log(error)
        }
        return
      }

      try {
        const params = {
          id: this.rowData.id,
          list: this.tableData.data,
          type: this.type
        }
        const res = !type
          ? await uploadOtherServiceExpenses(params)
          : await uploadAndAuditExpenses(params)
        this.loading = false
        if (res.success) {
          this.$emit('ok')
          this.reset()
          this.$message.success(res.errorMessage)
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        this.loading = false
        console.error(error)
      }
    },
    async GetFeeNameList() {
      try {
        const res = await GetFeeNameListById({ id: 15 })
        if (res.success) {
          const feeOptions = res.data.map((item) => {
            return {
              ...item,
              label: `${item.code}-${item.name}`,
              value: item.id
            }
          })
          this.feeOptions = feeOptions
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    editChange({ changedValue, row, col }) {
      if (changedValue && col === 0) {
        const feeNameId = this.feeOptions.find(
          (a) => a.label.indexOf(changedValue) > -1
        ).id
        this.$set(this.tableData.data[row - 2], 'feeNameId', feeNameId)
      }
    },
    async iconClick({ row, targetIcon }) {
      const rowData = this.tableData.data[row - 2]
      if (targetIcon?.name === 'delete') {
        if (rowData?.id) {
          try {
            const res = await deleteExpenses({ id: rowData.id })
            if (res.success) {
              this.tableData.data.splice(row - 2, 1)
            } else {
              this.$message.error(res.errorMessage)
            }
          } catch (error) {
            console.error(error)
          }
        } else {
          this.tableData.data.splice(row - 2, 1)
        }
      }
    },
    newAdd() {
      if (!this.entry) return
      let i = 0
      while (i < this.entry) {
        if (this.type === 1) {
          this.tableData.data.push({
            feeNameId: '',
            payableCount: 1,
            invoiceNumber: '',
            payableUnitPrice: 0,
            payableAmount: 0,
            payableRemark: ''
          })
        } else {
          this.tableData.data.push({
            feeNameId: '',
            receivableCount: 1,
            receivableUnitPrice: 0,
            receivableAmount: 0,
            receivableRemark: ''
          })
        }
        i++
      }
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  .header {
    width: 100%;
    height: auto;
    padding: 20px 24px;
    display: flex;
    flex-wrap: wrap;
    background: #f7f7f7;
    border-radius: 6px 6px 6px 6px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    box-sizing: border-box;
    margin-bottom: 16px;
    .item {
      display: flex;
      width: 25%;
      .label {
        display: inline-block;
        width: 70px;
        height: 14px;
        color: #666666;
      }
      .value {
        display: inline-block;
        width: calc(100% - 90px);
        height: auto;
        color: #333333;
        margin-left: 20px;
      }
      &:nth-child(n + 5) {
        margin-top: 20px;
      }
      .btn {
        width: 60px;
        height: 40px;
        background: #2395f3;
        border-radius: 4px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        line-height: 40px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
  .data {
    width: 100%;
    height: 600px;
    .total {
      display: flex;
      align-items: center;
      width: 100%;
      height: 50px;
      background: #f7f7f7;
      border-radius: 4px 4px 4px 4px;
      padding-left: 24px;
      box-sizing: border-box;
      & > span {
        + span {
          margin-left: 20px;
        }
        .num {
          color: #fe453d;
        }
      }
    }
  }
}
.footers {
  display: flex;
  justify-content: center;
  & > div {
    width: 120px;
    height: 40px;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    cursor: pointer;
    + div {
      margin-left: 16px;
    }
  }
  .cancel {
    background: #eeeeee;
    color: #999999;
  }
  .ok {
    background: #2395f3;
    color: #ffffff;
  }
}
</style>
